import { getSessionId, getUserId, trackApiCall } from './datadog-rum';

const isDatadogUrl = (url: string) =>
  url.includes('datadoghq.com') || url.includes('browser-intake-');

export const setupApiInterceptor = () => {
  const originalFetch = window.fetch;

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const startTime = performance.now();
    const url = typeof input === 'string' ? input : input.toString();
    const method = init?.method || 'GET';

    let modifiedInit = { ...init };

    if (!isDatadogUrl(url)) {
      const headers = new Headers(init?.headers);
      headers.set('X-Datadog-Session-Id', getSessionId());
      headers.set('X-Datadog-User-Id', getUserId());
      headers.set('X-Datadog-Trace-Id', generateTraceId());
      modifiedInit.headers = headers;
    }

    try {
      const response = await originalFetch(input, modifiedInit);
      const endTime = performance.now();
      const duration = endTime - startTime;

      trackApiCall(url, method, response.status, duration, {
        url,
        method,
        status_code: response.status,
        duration_ms: Math.round(duration),
      });

      return response;
    } catch (error) {
      const endTime = performance.now();
      const duration = endTime - startTime;

      trackApiCall(url, method, 0, duration, {
        url,
        method,
        error: error instanceof Error ? error.message : 'Unknown error',
        duration_ms: Math.round(duration),
      });

      throw error;
    }
  };
};

const generateTraceId = (): string => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
};

export const setupXHRInterceptor = () => {
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method: string, url: string | URL, async: boolean = true, username?: string | null, password?: string | null) {
    (this as any)._rumData = {
      method,
      url: url.toString(),
      startTime: performance.now(),
    };
    (this as any)._isDatadog = isDatadogUrl(url.toString());
    return originalOpen.call(this, method, url, async, username, password);
  };

  XMLHttpRequest.prototype.send = function(data?: any) {
    const originalOnReadyStateChange = this.onreadystatechange;

    this.onreadystatechange = function(ev: Event) {
      if (this.readyState === 4) {
        const rumData = (this as any)._rumData;
        if (rumData) {
          const endTime = performance.now();
          const duration = endTime - rumData.startTime;

          trackApiCall(rumData.url, rumData.method, this.status, duration, {
            url: rumData.url,
            method: rumData.method,
            status_code: this.status,
            duration_ms: Math.round(duration),
          });
        }
      }

      if (originalOnReadyStateChange) {
        originalOnReadyStateChange.call(this, ev);
      }
    };

    if (!(this as any)._isDatadog) {
      this.setRequestHeader('X-Datadog-Session-Id', getSessionId());
      this.setRequestHeader('X-Datadog-User-Id', getUserId());
      this.setRequestHeader('X-Datadog-Trace-Id', generateTraceId());
    }

    return originalSend.call(this, data);
  };
}; 